<p-dialog
  [(visible)]="visible"
  (onHide)="visibleChange.emit(false)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closable]="false"
  [style]="{ width: '760px' }"
  [breakpoints]="{ '1024px': '85vw', '640px': '96vw' }"
  styleClass="loca-onboard-dialog"
  contentStyleClass="p-0"
>
  <ng-template pTemplate="header">
    <div class="loca-onboard-header">
      <span class="loca-onboard-title">Asistente de Bienvenida</span>
    </div>
  </ng-template>

  <div class="loca-onboard-body">
    <!-- Ilustración -->
    <img
      *ngIf="currentStep.img"
      [src]="currentStep.img"
      alt=""
      class="loca-onboard-hero"
    />

    <!-- Títulos y copy -->
    <h2 class="loca-onboard-h2">{{ currentStep.title }}</h2>
    <p class="loca-onboard-sub">{{ currentStep.subtitle }}</p>

    <!-- Contenido por paso -->
    <div class="loca-onboard-content">
      <!-- Paso 1: NIF/CIF -->
      <ng-container *ngIf="step === 1">
        <div class="loca-onboard-content text-center">
          <div class="nif-row">
            <label for="nif" class="loca-field-label">NIF/CIF de Cliente</label>

            <p-iconField class="w-full">
              <p-inputIcon styleClass="pi pi-id-card"></p-inputIcon>
              <input
                pInputText
                id="nif"
                class="w-full"
                autocomplete="off"
                placeholder="Ej.: 12345678Z"
                [(ngModel)]="nif"
              />
            </p-iconField>

            <p-button
              label="Comprobar autorización"
              icon="pi pi-shield-check"
              [disabled]="!nif || isSubmitting"
              [loading]="isSubmitting"
              [style]="{ background: 'blue', border: 'none' }"
              (onClick)="submitNif()"
            ></p-button>
          </div>

          <small class="loca-help">
            Formato: 8 dígitos + letra. Sin espacios ni guiones.
          </small>

          <p-tag
            *ngIf="requestDone"
            [severity]="resultSeverity"
            [icon]="resultIcon"
            [value]="resultText"
            class="w-full justify-center py-3 mt-3 text-base"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <!-- Progress row: 3 slots fijos (izq / dots / dcha) -->
  <div class="loca-progress">
    <!-- Left slot (oculto visualmente en step 0, pero ocupa espacio) -->
    <p-button
      icon="pi pi-arrow-left"
      [rounded]="true"
      [text]="false"
      severity="success"
      class="loca-arrow loca-arrow-left"
      [style]="{ background: '#bfbfbf', border: 'none', width: '3rem', height: '3rem', padding: 0 }"
      [style.visibility]="step > 0 ? 'visible' : 'hidden'"
      [attr.tabindex]="step > 0 ? null : -1"
      [attr.aria-hidden]="step > 0 ? null : true"
      (onClick)="prev()"
    />

    <!-- Dots (siempre centrados) -->
    <ul class="loca-dots" aria-label="Progreso">
      <li
        *ngFor="let _ of steps; let i = index"
        [class.active]="i === step"
        [attr.aria-current]="i === step ? 'step' : null"
      ></li>
    </ul>

    <!-- Right slot -->
    <p-button
      [icon]="step === steps.length - 1 ? 'pi pi-check' : 'pi pi-arrow-right'"
      [rounded]="true"
      [text]="false"
      severity="primary"
      class="loca-arrow loca-arrow-right"
      [style]="{ background: '#10b981', border: 'none', width: '3rem', height: '3rem', padding: 0 }"
      (onClick)="step === steps.length - 1 ? skip() : next()"
    />
  </div>
</p-dialog>
